/** URL query param that pins the active Settings tab (e.g. `/settings?tab=notifications`). */
export const SETTINGS_TAB_PARAM = 'tab';

/** Stable ids shared by each Settings `Tabs.Tab` / `Tabs.Panel` pair and the `?tab=` param. */
export const SettingsTab = {
  MyAccount: 'my-account',
  Dependents: 'dependents',
  Notifications: 'notifications',
  Possessions: 'possessions',
  Billing: 'billing',
} as const;

export type SettingsTabKey = (typeof SettingsTab)[keyof typeof SettingsTab];

export const DEFAULT_SETTINGS_TAB: SettingsTabKey = SettingsTab.MyAccount;

/**
 * Resolve the active tab from a raw `?tab=` value. Falls back to
 * {@link DEFAULT_SETTINGS_TAB} when the value is missing, unrecognized, or names
 * a tab not currently available (e.g. `dependents` for a household with none).
 */
export const resolveSettingsTab = (rawParam: string | null, availableTabs: readonly SettingsTabKey[]): SettingsTabKey =>
  availableTabs.find((tab) => tab === rawParam) ?? DEFAULT_SETTINGS_TAB;
